import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const MassageCenterHistoryHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>Massage Center History</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default MassageCenterHistoryHeader;
